import { Link as MuiLink } from "@mui/material";
import { BreadcrumbsProps } from "@mui/material/Breadcrumbs";
import MuiBreadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "next/link";

export default function Breadcrumb({
  items,
  ...props
}: BreadcrumbsProps & { items: { label: string; href?: string }[] }) {
  return (
    <MuiBreadcrumbs aria-label="breadcrumb" {...props}>
      {items.map((item) => {
        if (item.href) {
          return (
            <MuiLink component={Link} key={item.href} href={item.href}>
              {item.label}
            </MuiLink>
          );
        }

        return (
          <Typography color="text.primary" key={item.label}>
            {item.label}
          </Typography>
        );
      })}
    </MuiBreadcrumbs>
  );
}
